exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hideElement {\n  visibility: hidden;\n}\n.order-pagination__select {\n  background-color: #f2f2f2;\n  border-color: #e1e1e1;\n  text-transform: none;\n}\n@media (min-width: 1024px) {\n.order-pagination__select {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    background-color: #ffffff;\n}\n}\n", ""]);

// exports
